import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import MaterialTable from 'material-table';

import { Link } from 'react-router-dom';
import { Field } from 'redux-form';
import TextInput from 'components/TextInput';

import ModalRoot from 'components/Modal/ModalRoot';

import { RenderIconButton } from '../../Channel/shared/components/GenericComponents';

import { Edit } from '@material-ui/icons';

const styles = theme => ({
  content: {
    backgroundColor: '#F4F8F9',
    flexGrow: 1,
    flexDirection: 'column',
  },
  title: {
    ...theme.Typography,
    color: '#044591',
  },
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 26,
  }),
  bottomContainer: {
    display: 'flex',
    marginTop: theme.spacing(2),
    justifyContent: 'flex-end',
  },
  table: { width: '100%', margin: '10px' },
});

export class PassKitInfo extends Component {
  state = {
    selectedRow: '',
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  truncate = (str, maxSize) => {
    return str.length > maxSize ? str.substring(0, maxSize) + '...' : str;
  };

  renderAddPassKitInfo = () => {
    const { classes, handleSubmit, onCancel } = this.props;

    return (
      <form
        onSubmit={handleSubmit}
        className={classes.content}
        noValidate
        autoComplete="off"
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography className={classes.title} variant="h6">
              {this.state.selectedRow !== '' ? 'Edit ' : 'Add '} PassKit Info
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Paper className={classes.root} elevation={0}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    label="Token"
                    name="token"
                    placeholder="Enter Token"
                    component={TextInput}
                    fullWidth
                    required
                  />
                </Grid>

                <Grid item xs={6}>
                  <Field
                    label="Template Name"
                    name="template"
                    type="text"
                    placeholder="Enter Template name"
                    component={TextInput}
                    inputProps={{ maxLength: 100 }}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={6}>
                  <Field
                    label="Email Subject"
                    name="subject"
                    placeholder="Enter an Email Subject"
                    component={TextInput}
                    inputProps={{ maxLength: 100 }}
                    fullWidth
                    required
                  />
                </Grid>

                <Grid item xs={7}>
                  <Field
                    label="Message"
                    name="message"
                    placeholder="Enter message"
                    component={TextInput}
                    fullWidth
                    required
                  />
                </Grid>

                <Field
                  name="id"
                  type="hidden"
                  component={TextInput}
                  style={{ height: 0 }}
                />
              </Grid>

              <div className={classes.bottomContainer}>
                <Button
                  variant="text"
                  color="default"
                  className={classes.button}
                  type="button"
                  onClick={() => {
                    this.handleChange('selectedRow', '');
                    onCancel();
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="text"
                  color="primary"
                  className={classes.button}
                  onClick={() => this.handleChange('selectedRow', '')}
                >
                  Save
                </Button>
              </div>
            </Paper>
          </Grid>
        </Grid>
        <ModalRoot />
      </form>
    );
  };

  renderPassInfoTable = () => {
    const { classes, passInfoList, updatePassInfo } = this.props;
    return (
      <MaterialTable
        className={classes.table}
        dense
        elevation={0}
        xs={12}
        options={{
          pageSizeOptions: [5, 10, 20],
          toolbar: true,
          paging: true,
          emptyRowsWhenPaging: false,
        }}
        columns={[
          {
            cellStyle: { padding: '4px 15px 4px 15px' },
            headerStyle: { padding: '4px 15px 4px 15px' },
            title: 'Campaign Name',
            field: 'campaignName',
            customSort: (a, b) =>
              a.campaignName.toLowerCase().localeCompare(b.campaignName.toLowerCase()),
          },
          {
            cellStyle: { padding: '4px 15px 4px 15px' },
            headerStyle: { padding: '4px 15px 4px 15px' },
            title: 'Template Name',
            field: 'template',
            customSort: (a, b) =>
              a.template.toLowerCase().localeCompare(b.template.toLowerCase()),
          },
          {
            cellStyle: { padding: '4px 15px 4px 15px' },
            headerStyle: { padding: '4px 15px 4px 15px' },
            title: 'Subject',
            field: 'subject',
            customSort: (a, b) =>
              a.subject.toLowerCase().localeCompare(b.subject.toLowerCase()),
          },
          {
            cellStyle: { padding: '4px 15px 4px 15px' },
            headerStyle: { padding: '4px 15px 4px 15px' },
            title: 'Message',
            field: 'message',
            render: rowData => this.truncate(rowData.message, 20),
            sorting: false,
          },
          {
            cellStyle: { padding: '4px 15px 4px 15px' },
            headerStyle: { padding: '4px 15px 4px 15px' },
            title: 'State',
            field: 'active',
            render: rowData => {
              if (rowData.active) {
                return 'Active';
              } else {
                return 'Inactive';
              }
            },
          },
          {
            cellStyle: { padding: '4px 15px 4px 15px' },
            headerStyle: { padding: '4px 15px 4px 15px' },
            title: 'Options',
            render: row => (
              <div>
                <RenderIconButton
                  clickEvent={() => {
                    this.handleChange('selectedRow', row._id);
                    updatePassInfo(row, this.props);
                  }}
                  title={'Edit Pass Info'}
                  placement={'top'}
                  component={Link}
                  icon={<Edit />}
                  color={'primary'}
                />
              </div>
            ),
            sorting: false,
          },
        ]}
        data={passInfoList}
        title="Pass Info"
      />
    );
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <div>{this.renderAddPassKitInfo()}</div>
        <div className={classes.content}>{this.renderPassInfoTable()}</div>
      </div>
    );
  }
}

export default withStyles(styles)(PassKitInfo);
